import React from 'react';
import {RowContext, TableContext} from "@q4us-sw/q4us-ui/lib/TableV2";
import {Form} from '@q4us-sw/q4us-ui'
import {MapToFilter} from "../utils/mappings";
import moment from "moment";
import {
    Button,
    Modal,
    notification,
    Space,
    Tooltip,
    Typography,
    Input,
    Row,
    Col,
    Statistic,
    Tag
} from "antd";

import {Q4USUtil} from "@q4us-sw/q4us-util";
import {
    em_vat_report_fiscal_import,
    em_vat_report_fiscal_non_union,
    em_vat_report_fiscal_union,
    setFiscalVATPayment,
    fetchIntermediaryInstructions,
    downloadFiscalReportInXlsx, submitRefTableData,
    em_vat_report_fiscal_non_eu_gb,
    visualizeLoadFiscalReportList
} from "../api/api";

import {
    CheckCircleFilled,
    CheckCircleOutlined, CommentOutlined,
    FilePdfOutlined,
    FileTextOutlined,
    FileExcelOutlined,
    KeyOutlined,
    ProfileOutlined
} from "@ant-design/icons";

import {RefTable, DefaultProps} from './RefTable';
import {unstable_batchedUpdates} from "react-dom";

const {TextArea} = Input

const NotNullOrEmptyString = (str)=> str && str.trim() !== "";

export const getTableName = ({report_type})=>{
    switch (report_type) {
        case "ioss":
            return "em_vat_report_generated_fiscal_import";
        case "non_eu_ioss":
            return "em_vat_report_generated_fiscal_non_eu_gb";
        case "non_union":
            return "em_vat_report_generated_fiscal_non_union";
        case "union":
            return "em_vat_report_generated_fiscal_union";
        default:
            return undefined
    }
}

export const updateVatTable = async (row, delta)=>{
    const tableName = getTableName(row)
    if(tableName){
        await submitRefTableData({id: row.id, ...delta}, tableName)
    }else
        notification.error({message: "Report type not detected"})
}

export const PaginatedLoad = async (tableName, filters = {}, page = {})=>{
    const _filters = MapToFilter(filters)
    return await visualizeLoadFiscalReportList({
        tableName: tableName,
        orderBy: ['status asc','timestamp desc', 'client asc'],
        filter:[..._filters],
        page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
    }) || {}
}

const reloadTableByContext = async (table)=>{
    table?.setLoading(true)
    const request  = {
        options: {
            filter : table?.customData?.filter,
        },
        page: table?.page,
        schema: table?.props.schema
    }
    const res = await table?.props?.fetchData(request);
    unstable_batchedUpdates(() => {
        table?.setData(res.data?.rows || [])
        if(res.data?.page){
            table?.setPage({
                current: res.data?.page?.current || table?.page?.current || 0,
                total: res.data?.page?.total || table?.page?.total || 0,
                size: table?.page?.size || table?.props.defaultPageSize || 100,
                vat_amount_reported: res.data?.page?.vat_amount_reported || table?.page?.vat_amount_reported || 0.00, //ToDo: this should set as customData
                vat_amount_to_be_reported: res.data?.page?.vat_amount_to_be_reported || table?.page?.vat_amount_to_be_reported || 0.00, //ToDo: this should set as customData
            })
        }
        table?.setLoading(false)
    })
}


export const ToolButton = ({title, icon, onClick, btnProps = (row) => ({}), children}) => {
    return <div>
        <RowContext.Consumer>
            {
                row =>
                    <Tooltip title={title}>
                        <Button onClick={async () => onClick(row)} icon={icon} {...btnProps(row)}>
                            {children}
                        </Button>
                    </Tooltip>
            }
        </RowContext.Consumer>
    </div>


}

export const PaymentCompletion = ({title}) => {
    const [data, setData] = React.useState(undefined)
    return <React.Fragment>
        <RowContext.Consumer>
            {row => <ToolButton title={title}
                                btnProps={(r) => ({style: {color: r?.row.status === 'submitted' ? "#52c41a" : "#262626"}})}
                                icon={(row?.row.status === 'submitted' ? <CheckCircleFilled color={"#52c41a"}/> :
                                    <CheckCircleOutlined/>)} onClick={async (r) => setData(r?.row)}>

            </ToolButton>}
        </RowContext.Consumer>
        {
            data && <Modal
                title={`Filing for [${data.client}] ${data.year}/${data.report_period_name?.trim()}`}
                visible={true}
                closable={false}
                centered={true}
                footer={null}
                onCancel={() => setData(undefined)}
            >
                <TableContext.Consumer>
                    {table=><Form
                        schema={""}
                        initialValue={{
                            report_date: data?.report_date || moment(),
                            reported_vat_amount: data?.reported_vat_amount || data?.total_vat_due || 0.00,
                            comment: data?.comment
                        }}
                        config={async () => [
                            {name: "report_date", title: "Reported date", type: "DATE"},
                            {name: "reported_vat_amount", title: "Reported VAT amount", type: "NUMBER", precision: 2},
                            {name: "comment", title: "Comment", type: "STRING"}
                        ]}
                        overrideComponent={(schema, element, form) => {
                            if (element.name === "comment") {
                                return <TextArea/>
                            }
                        }}
                        submit={(values) => {

                            Modal.confirm({
                                title: "Confirmation",
                                content: "Please confirm that report was filed to the Authorities.",
                                onOk: async ()=>{
                                    await setFiscalVATPayment({row: data, delta: {...values, status: "submitted"}})
                                    await reloadTableByContext(table)
                                    setData(undefined)
                                }
                            })

                        }}
                        rejectText={"Cancel"}
                        validateField={(rule, value, schema, column, form) => {
                            if (column.name === "comment" && (!NotNullOrEmptyString(value))) {
                                if(Q4USUtil.roundToDecimal(form.getFieldValue("reported_vat_amount") || 0,2) !== Q4USUtil.roundToDecimal(data.total_vat_due || 0, 2))
                                    return Promise.reject("Comment is required")
                            }
                            return Promise.resolve()
                        }}
                        rejected={(f) => {
                            setData(undefined)
                        }}
                    />}
                </TableContext.Consumer>


            </Modal>
        }
    </React.Fragment>

}


export const AddEditComments = ()=>{

    const [data, setData ]= React.useState()
    return <React.Fragment>
        <ToolButton title={"Add or edit comments for the report"}
                    btnProps={(r) => ({style: {color: NotNullOrEmptyString(r?.row.comment) ? "#3173e7" : "#262626"}})}
                    icon={<CommentOutlined/>} onClick={async (r) => setData(r?.row)}/>

        {
            data &&  <TableContext.Consumer>
                {table=><Modal
                    title={`Comments for [${data.client}] ${data.year}/${data.report_period_name?.trim()} ${data.report_type}`}
                    visible={true}
                    closable={false}
                    centered={true}
                    onCancel={() => setData(undefined)}
                    confirmLoading={table?.loading}
                    onOk={async ()=>{
                        await updateVatTable(data, {comment: data?.comment})
                        await reloadTableByContext(table)
                        setData(undefined)
                    }}
                >
                    <TextArea value={data?.comment} onChange={(e)=> {
                        setData({...data,comment: e.currentTarget.value})
                    }}/>
                </Modal>}
            </TableContext.Consumer>

        }

    </React.Fragment>

}

/*
* Tool Actions
*
* */
const downloadReport = async (row, type) => {
    const {report_type, em_id, em_identifier, report_period, year} = row?.row || {}
    switch (report_type) {
        case "ioss":
            return await em_vat_report_fiscal_import(em_id, report_period, year, type, em_identifier);
        case "non_union":
            return await em_vat_report_fiscal_non_union(em_id, report_period, year, type, em_identifier);
        default:
            return await em_vat_report_fiscal_union(em_id, report_period, year, type, em_identifier);
    }
}
export const downloadPdf = async (row) => downloadReport(row, 'pdf')
export const downloadXlsx = async (row) => downloadReport(row, 'xlsx')


const downloadCountrySpecific = async (row) => {
    const {report_type, em_id, em_identifier, report_period, year, scheme_registered_country_code} = row?.row || {}
    switch (report_type) {
        case "ioss":
            const _ioss = {SE: 'txt', EE: 'xml'};
            return await em_vat_report_fiscal_import(em_id, report_period, year, _ioss[scheme_registered_country_code] || 'csv', em_identifier, scheme_registered_country_code)
        case "non_eu_ioss":
            return await em_vat_report_fiscal_non_eu_gb(em_id, report_period, year, 'csv')
        case "non_union":
            const non_union = {SE: 'txt'};
            return await em_vat_report_fiscal_non_union(em_id, report_period, year, non_union[scheme_registered_country_code] || 'csv', em_identifier, scheme_registered_country_code)
        default:
            const union = {SE: 'txt'};
            return await em_vat_report_fiscal_union(em_id, report_period, year, union[scheme_registered_country_code] || 'csv', em_identifier, scheme_registered_country_code)

    }
}


export const EMVATFiscalReportListViewV1 = (props) => <RefTable {...props}>
    <TableContext.Consumer>
        {
            table => <Space className={"custom-space-content"} direction={`vertical`} style={{backgroundColor: "white", width: "100%", padding:"0px 10px", margin:"0px 15px"}}>
                <Row gutter={{xs: 8, sm: 160, md: 240, lg: 320, xl:400} } style={{}}>
                    <Col>
                        <Statistic title={"VAT amount reported"} value={Q4USUtil.roundToDecimal(table?.page?.vat_amount_reported)}/>
                    </Col>
                    <Col>
                        <Statistic title={"VAT amount to be reported"} value={Q4USUtil.roundToDecimal(table?.page?.vat_amount_to_be_reported)}/>
                    </Col>
                </Row>
            </Space>
        }
    </TableContext.Consumer>
</RefTable>

EMVATFiscalReportListViewV1.defaultProps = {
    ...DefaultProps,
    tableSchema: 'fiscal_vat_list_info',
    tableName: 'fiscal_vat_report_list',
    filterSchema: "fiscal_vat_list_info_filter",
    theadHeight: 61,
    tfootHeight: 150,
    headerChildHeight: 125,
    initialValue:{
        to_timestamp: moment().utc().endOf('month'),
        payment_handling_mode: 'indirect',
        from_timestamp: moment().month() !== 0 ? moment().utc().set('month', 1).startOf('month') : moment().utc().subtract(1, 'year').set('month', 1).startOf('month')
    },
    title: "EM VAT Reports - Fiscal",
    enrichColumns: async (columns) => {
        return [
            {
                name: "__id__",
                fixed: true,
                title: "",
                width: 120
            }, ...columns]
    },
    add: false,
    edit: false,
    fetch: PaginatedLoad,
    rowKey: "global_id",
    customActionElements: [
        <TableContext.Consumer>
            {button => <Button type={"primary"} onClick={async () => {
                const {filter: a} = button.customData
                const filter = MapToFilter(a);
                await downloadFiscalReportInXlsx({
                    tableName: "fiscal_vat_report_list",
                    filter,
                    templateName: "fiscal_vat"
                })
            }}>
                Export to excel
            </Button>}
        </TableContext.Consumer>
    ],
    customRenderer: {
        comment: (value) => <div style={{maxWidth: '250px', wordWrap: 'word-break', textAlign: 'left'}}>{value}</div>,
        __id__: (value, data) => <Space>
                <ToolButton title={"Download report in PDF format"} icon={<FilePdfOutlined/>}
                            onClick={downloadPdf}
                            btnProps={(row) => ({disabled: (row?.row.report_type === 'non_eu_ioss')})}/>
                <ToolButton title={"Download report in the Country specific format  or CSV"} icon={<FileTextOutlined/>}
                            onClick={downloadCountrySpecific}/>
                <ToolButton title={"Download report in the Excel format"} icon={<FileExcelOutlined/>}
                            onClick={downloadXlsx}
                            btnProps={(row) => ({disabled: (row?.row.report_type === 'non_eu_ioss')})}/>
                <PaymentCompletion title={"Mark as filed or edit filing information"}/>
                <ToolButton title={"Use these account details for reporting"} icon={<KeyOutlined/>}
                            onClick={async (row) => {
                                Modal.info({
                                    title: "Account details",
                                    content: <Typography.Paragraph>{row?.row.access_information}</Typography.Paragraph>
                                })
                            }} btnProps={(row) => ({disabled: (row?.row.access_information === null)})}/>
                <ToolButton title={"Download reporting instructions"} icon={<ProfileOutlined/>}
                            onClick={async (row) => await fetchIntermediaryInstructions(row?.row.intermediary_info_id, row?.row.instructions_file_name)}
                            btnProps={(row) => ({disabled: (row?.row.instructions_file === null)})}/>
                <AddEditComments/>
            </Space>,
        report_date: (value)=> value ? moment(value).format("YYYY-MM-DD"): "",
        invoice_payment_status: (value) => {
            switch (value) {
                case 'overdue':
                    return <Tag color="red">{value.toUpperCase()}</Tag>;
                case 'pending':
                    return <Tag color="blue">{value.toUpperCase()}</Tag>;
                case 'paid':
                    return <Tag color="green">{value.toUpperCase()}</Tag>;
                case 'partially_paid':
                    return <Tag color="yellow">{value.toUpperCase()}</Tag>;
                case null:
                    return <Tag color="red">NO_INVOICE_FOUND</Tag>;
                default:
                    return <Tag >{value.toUpperCase()}</Tag>;
            }}
    }
}

